module.exports = __webpack_public_path__ + "static/img/check.306d65d.svg";